export default __webpack_public_path__ + "static/media/CreditImage.fa20b1fb.svg";